module.exports = __webpack_public_path__ + "static/media/md-switch.74c01611.svg";